import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  private error = new BehaviorSubject<string>('');

  public currentError = this.error.asObservable();


  constructor() { }


  public setError(error: string) {
    this.error.next(error);
  }

}
